
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.71 20.217l-7.593 7.537-5.891 5.847c-.393.39-1.833 1.689-2.226 2.339-.393-.65-1.964-1.95-2.226-2.34l-5.367-5.327-8.117-8.056c-1.178-1.169-1.702 2.73-.916 3.509l16.102 15.982c.393.39.524.39.917 0l16.233-16.112c.786-.65.262-4.548-.916-3.379z"}}),_c('path',{attrs:{"d":"M29.826 0C13.522 0 1 14.087 1 30s12.522 30 28.826 30c16.696 0 28.435-14.087 28.826-30-.391-15.913-12-30-28.826-30zm0 55.956c-14.087 0-27-11.478-27-25.956 0-14.217 12.391-25.435 26.218-25.957C43.782 3.653 56.565 15.13 56.956 30c-.39 14.478-12.652 25.956-27.13 25.956z"}})])
          )
        }
      }
    